import ZERONE_COLORS from "./ZeroneColors";

const SERIES_COLORS = [
  ZERONE_COLORS.primary,
  ZERONE_COLORS.secondary,
  '#4CAF50',
  '#9C27B0',
  '#FF9800',
  '#03A9F4',
  '#E91E63',
  '#795548',
];


/**
 * Returns a color for a series based on its index.
 * Cycles through the SERIES_COLORS array if the index exceeds its length.
 *
 * @param {number} index - The index of the series.
 * @returns {string} - The color for the series.
 */
export const getSeriesColor = (index: number): string => {
  return SERIES_COLORS[index % SERIES_COLORS.length] ?? ZERONE_COLORS.primary;
};